import $api from "@/api/index";
import { toFormData } from "@/utils/network";
import { UserForm } from "@/store/userProfileForm";
import { useReferralStore } from "@/store/referral";

export async function getTokenWithEmail(email: string, password: string) {
  const res = await $api.post("/auth/login/", {
    email,
    password,
  });

  return res.data;
}

export async function getTokenWithVK({
  code,
  deviceId,
  codeVerifier,
  redirectUri,
}: {
  code: string;
  deviceId: string;
  codeVerifier: string;
  redirectUri: string;
}) {
  const res = await $api.post("/auth/social/vk-id/", {
    code,
    device_id: deviceId,
    code_verifier: codeVerifier,
    redirect_uri: redirectUri,
  });

  return res.data;
}

export async function registerRequest(
  email: string,
  password1: string,
  password2: string,
  name: string,
  newsEmailEnabled: boolean,
  petEventsEmailEnabled: boolean,
  nextPath?: string | null
) {
  const { refCode } = useReferralStore.getState();
  const res = await $api.post("/auth/signup-request/", {
    email,
    name,
    news_email_enabled: newsEmailEnabled,
    pet_events_email_enabled: petEventsEmailEnabled,
    password1,
    password2,
    ...(refCode ? { ref_code: refCode } : {}),
    ...(nextPath ? { next: nextPath } : {}),
  });

  return res.data;
}

export async function registerConfirmToken({ token }: { token: string }) {
  const res = await $api.post("/auth/signup-confirm/", {
    token,
  });

  return res.data;
}

export async function resetPasswordRequest(email: string) {
  const res = await $api.post("/auth/password-reset-request/", {
    email,
  });

  return res.data;
}

export async function resetPasswordConfirmToken({
  token,
  newPassword,
}: {
  token: string;
  newPassword: string;
}) {
  const res = await $api.post("/auth/password-reset-confirm/", {
    token,
    new_password: newPassword,
  });

  return res.data;
}

export async function changePassword({
  oldPassword,
  newPassword,
}: {
  oldPassword: string;
  newPassword: string;
}) {
  const res = await $api.post("/auth/password-change/", {
    old_password: oldPassword,
    new_password: newPassword,
  });

  return res.data;
}

export async function getUser() {
  const res = await $api.get("/auth/user/");

  return res.data;
}

export async function patchUser(user: Partial<UserForm>) {
  const formData = toFormData(user);

  const res = await $api.patch(`/auth/user/`, formData);

  return res.data;
}
